import { JSX } from "react"

import config from "../../config.json"
import ValueInterface from "../../Model/Value/ValueInterface"

import "./value.css"

type Props = {
  value: ValueInterface
  displayValue: boolean
}

export default function ValueView({ value, displayValue }: Props): JSX.Element {
  return (
    <span className={`value${displayValue ? " displayed" : ""}`}>
      <span className="equation">
        {value.toString()}
        {config.debug && !displayValue && ` (${value.normalize()})`}
      </span>
      {displayValue && <span className="normalized">{value.normalize()}</span>}
    </span>
  )
}
